<template>
  <aqt-table add @on-add="addData" del @on-del="delData" refresh @on-refresh="refreshData" :pageDate="pageDate" @on-pageChange="refreshData">
<!--    <div slot="table" style="margin-bottom: 10px; display: flex">-->
<!--      <Input v-model="query.username" search placeholder="用户名" @on-search="refreshData(1)" style="width: 200px; margin-right: 10px"/>-->
<!--    </div>-->
    <Table border stripe :loading="tableLoading" :columns="columns" @on-selection-change="removeData" :data="data" slot="table"></Table>
    <aqt-sidebar v-model="show" :title="titles" slot="others">
      <component :is="content" :condition="condition" @operationState="operationState"></component>
    </aqt-sidebar>

  </aqt-table>
</template>

<script>
export default {
  components: {
    Operation: resolve => {require(['./Operation.vue'], resolve);},
  },
  data() {
    return {
      tableLoading: false,
      show: false,
      titles: '',
      content: '',
      condition: false,
      pageDate: {
        total: 1,
        current_page: 1,
        per_page: 1,
      },
      data:[],
      columns: [
        {
          type: 'selection',
          width: 80,
          align: 'center'
        },
        {
          title: '标题',
          minWidth: 100,
          align: 'center',
          key: 'title',
        },
        {
          title: '别名',
          minWidth: 100,
          align: 'center',
          key: 'alis',
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled:params.row.users_id==1?true:false
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.editData (params.row)
                  }
                }
              }, '修改'),
              h('Poptip', {
                props: {
                  confirm: true,
                  transfer: true,
                  title: '您确定要删除这条数据吗?',
                  type: 'error',
                  size: 'small',
                  placement:'left-end'
                },
                style: {
                  textAlign: 'left',
                },
                on: {
                  'on-ok': () => {
                    this.del = [params.row.manuscript_class_id];
                    this.delSubmit ();
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    disabled:params.row.users_id==1?true:false
                  }
                }, '删除')
              ]),
            ]);
          }
        }
      ],
      query:{
        library_id:localStorage.getItem('libId'),
      },
      del: [],
    }
  },
  methods: {

    /*****************************************************************
     *
     * 添加数据返回状态
     * @param   {data}             状态
     *
     *****************************************************************/
    operationState (data) {
      if (data) this.show = false
      this.refreshData (this.pageDate.current_page)
    },

    /************************************************************
     *
     * 添加数据
     *
     ************************************************************/
    addData () {
      this.condition = false
      this.content = 'Operation'
      this.titles = '添加'
      this.show = true
    },
    /************************************************************
     *
     * 修改数据
     * @param   {index}               id
     *
     ************************************************************/
    editData (val) {
      this.condition = val
      this.content = 'Operation'
      this.titles = '修改'
      this.show = true
    },

    /************************************************************
     *
     * 单条删除
     * @param   {id}               id
     *
     ************************************************************/
    removeData (item) {
      this.del=item.map(e =>  e.manuscript_class_id);
    },

    /************************************************************
     *
     * 删除确认
     *
     ************************************************************/
    delData () {
      if(!this.del.length){
        this.$Message.warning('请选择要删除的内容')
        return
      }
      this.$Modal.confirm({
        title: '删除确认',
        closable: true,
        loading: true,
        content: '您确定要删除这些数据吗?',
        onOk: () => {
          this.delSubmit ()
        }
      })
    },

    /************************************************************
     *
     * 删除操作
     *
     ************************************************************/
    delSubmit () {
      let cond = {
        id:JSON.stringify(this.del)
      }
      this.$httpsencrypt.post('api/contributeweb/v3/manuscriptclass/dels' ,cond).then(val=>{
        this.$Modal.remove ()
        this.refreshData (this.pageDate.current_page)
        this.$Message.success('删除成功!');
        this.del=[]
      }).catch(err => {
        this.$Modal.remove ()
        this.$Message.error('删除失败!');
      })
    },

    /************************************************************
     *
     * 列表数据
     *
     ************************************************************/
    queryData (index) {
      const _this = this
      _this.query.page = index
      _this.$httpsencrypt.post(`api/contributeweb/v3/manuscriptclass/list`,_this.query)
          .then(val =>{
            _this.data = val.data;
            _this.tableLoading = false;
            _this.pageDate.current_page = val.pages.current_page;
            _this.pageDate.per_page = val.pages.per_page;
            _this.pageDate.total = val.pages.total;
          }).catch(err =>{
        _this.tableLoading=false;
      })
    },

    /************************************************************
     *
     * 刷新
     *
     ************************************************************/
    refreshData (index) {
      this.data = []
      this.tableLoading = true
      this.queryData (index ? index : 1)
    }
  },
  created() {
    this.refreshData ()
  },
};
</script>

<style lang="less" scoped>
</style>
